import io from "socket.io-client";

// This is the socket URL development link
export const Socket_URL = process.env.REACT_APP_SOCKET_URL;

export const socket = io(Socket_URL, {
  autoConnect: false,
});
